import React from "react";
import CardSlider from "../Slider/Slider";
import HeaderSliderCard from "../HeaderSlider/HeaderSliderCard/HeaderSliderCard";
import styles from "./HeaderSlider.module.scss"; // Імпортуємо SCSS модуль

// Визначаємо тип для кожного зображення
interface SliderImage {
  src1920: string; // Зображення для 1920px
  src1440: string; // Зображення для 1440px
  src768: string; // Зображення для 768px
  src320: string; // Зображення для 320px
  alt: string; // Опис зображення
  imageType?: "full" | "partial"; // Тип зображення (необов'язковий, за замовчуванням full)
  className?: string; // Додатковий клас для спеціальних стилів
}

// Визначаємо тип для пропсів компонента HeaderSlider
interface HeaderSliderProps {
  images: SliderImage[]; // Пропс для прийому масиву зображень
}

const HeaderSlider: React.FC<HeaderSliderProps> = ({ images }) => {
  const sliderSettings = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      prevEl: `.${styles.customPrev}`,
      nextEl: `.${styles.customNext}`,
    },
    pagination: {
      clickable: true,
      el: `.${styles.swiperPagination}`,
    },
  };

  return (
    <div className={styles.sliderWrapper}>
      <CardSlider settings={sliderSettings}>
        {images.map((image) => (
          <HeaderSliderCard
            key={image.src1920} // Використовуємо унікальний ключ, наприклад src1920
            imageSrc1920={image.src1920}
            imageSrc1440={image.src1440}
            imageSrc768={image.src768}
            imageSrc320={image.src320}
            alt={image.alt}
            imageType={image.imageType || "full"} // Якщо imageType не передано, використовуємо "full" за замовчуванням
            className={image.className} // Передаємо додатковий клас
          />
        ))}
      </CardSlider>

      {/* Стрілки та пагінація в одному блоці */}
      <div className={styles.navigationWrapper}>
        {/* Custom Left Arrow */}
        <button className={styles.customPrev}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="none"
          >
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13.31 4 3 14l10.31 10M8.552 14H25"
            ></path>
          </svg>
        </button>

        {/* Пагінація */}
        <div className={styles.swiperPagination}></div>

        {/* Custom Right Arrow */}
        <button className={styles.customNext}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="none"
          >
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M14.69 4 25 14 14.69 24m4.758-10H3"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default HeaderSlider;
